var $5b7ed47241cec9bc$exports = {};
$5b7ed47241cec9bc$exports = {
  "collapse": "\u0421\u0432\u0438\u0432\u0430\u043D\u0435",
  "expand": "\u0420\u0430\u0437\u0448\u0438\u0440\u044F\u0432\u0430\u043D\u0435"
};
export { $5b7ed47241cec9bc$exports as default };